// https://htmldom.dev/scroll-to-an-element-smoothly/
export function scrollToTarget(
  target: HTMLElement,
  duration: number,
  offset: number = 125
): void {
  if (!target) {
    return;
  }

  const top = target.getBoundingClientRect().top;
  const startPos = window.scrollY;
  const diff = top - offset;

  let startTime: any = null;
  let requestId: any;

  const loop = function (currentTime: number) {
    if (!startTime) {
      startTime = currentTime;
    }

    // Elapsed time in miliseconds
    const time = currentTime - startTime;

    const percent = Math.min(time / duration, 1);
    window.scrollTo(0, startPos + diff * percent);

    if (time < duration) {
      // Continue moving
      requestId = window.requestAnimationFrame(loop);
    } else {
      window.cancelAnimationFrame(requestId);
    }
  };
  requestId = window.requestAnimationFrame(loop);
}
